/**
 * Deep E: an amoeba grows in a brick pit whose rim has an expanding wall at one end. Dig along
 * the rim and the wall follows you, sealing the pit; the trapped amoeba turns to diamonds. Leave
 * it and it spills out into the cave (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepE: CaveDef = {
  id: 'E',
  name: 'PRESSURE',
  hint: 'Seal the pit before the amoeba climbs out of it.',
  intermission: false,
  colors: [5, 14, 1],
  diamondValue: 18,
  extraValue: 28,
  amoebaTime: 40,
  fill: { base: '.', items: [['r', 10], ['d', 5]] },
  levels: [
    { seed: 5501, diamonds: 15, time: 150 },
    { seed: 5502, diamonds: 18, time: 140 },
    { seed: 5503, diamonds: 21, time: 130 },
    { seed: 5504, diamonds: 24, time: 120 },
    { seed: 5505, diamonds: 27, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????????????????????????????W',
    'W.X????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????.....????????????????W',
    'W?????????????????..P..????????????????W',
    'W?????????????????.....????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????..........??????????????W',
    'W??????????????wx.......w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w........w??????????????W',
    'W??????????????w...a....d.?????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
